<template>
  <div class="d-flex flex-0-1 text-left p-b-6">
    <div class="m-r-5"><img :src="testimonial.picture" class="IMG"></div>
    <div>
      <div class="h4 text-bold c-gray90">
        {{testimonial.title}}
      </div>
      <div class="p-b-4 TEXT">{{testimonial.description}}</div>
      <div class="LINE"></div>
      <div class="TEXT">{{testimonial.nameAndState }}</div>
      <div class="p-b-4 TEXT">{{professions}}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'testimonials-item',
  props: {
    testimonial: {
      type: Object,
      required: true,
    },
  },
  computed: {
    professions () {
      return this.testimonial.services.join(' | ');
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.validateContent();
    });
  },
  methods: {
    validateContent () {
      const missingProperties = [
        'description',
        'title',
        'picture',
        'nameAndState',
        'services',
      ].filter(property => !Object.prototype.hasOwnProperty.call(this.testimonial, property));
      if (Object.keys(this.testimonial).length < 1) {
        this.$emit('content-error');
      }
      if (missingProperties.length > 0) {
        this.$emit('content-error');
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.LINE {
  width: $unit * 28.75;
  border-bottom: 3px solid $color-depot;
  margin-bottom: $unit;
}
.TEXT {
  font-size: 18px;
}
.IMG {
  width: 200px;
  min-width: 200px;
  height: 200px;
}


</style>
